// extracted by mini-css-extract-plugin
export var growableInput = "_6m-0";
export var tagContainer = "_6m-2";
export var textInput = "_6m-1";